module.exports = __webpack_public_path__ + "static/media/logo_animated.ffa4fc50.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/images/logo_animated.svg
// module id = 301
// module chunks = 0